import { PaginationRequest } from '../config/common';

export class PaginationUserRequest extends PaginationRequest {
    name?: string = '';
    email?: string = '';
}

export interface CreateUserRequest {
    fullName?: string;
    email?: string;
    password?: string;
    branchIDs?: string[];
    customerID?: string;
    roles?: string[];
    menus?: number[];
}
